<template>
    <v-container>
        <v-layout>
            <v-flex xs12 sm10 offset-sm1 lg6 offset-lg3>
                <v-card>
                    <v-card-title primary-title>
                        <div>
                            <h3 class="headline mb-0" v-t="'title.activate_account'"></h3>
                        </div>
                    </v-card-title>
                    <v-form lazy-validation @submit.prevent="activate" v-model="valid" ref="form">
                        <v-card-text class="text--primary">
                            <v-alert
                                :value="true"
                                type="error"
                                v-for="error in errors"
                                :key="error"
                                >{{ $t(`error.${error}`) }}</v-alert
                            >
                            <v-text-field
                                :append-icon="showPassword ? 'visibility_off' : 'visibility'"
                                :rules="[rules.required, rules.min]"
                                :type="showPassword ? 'text' : 'password'"
                                :label="$t('label.set_password')"
                                :hint="$t('hint.at_least', { n: 8 })"
                                v-model="password"
                                required
                                @click:append="showPassword = !showPassword"
                            ></v-text-field>
                        </v-card-text>
                        <v-card-actions>
                            <v-spacer></v-spacer>
                            <v-btn
                                type="submit"
                                color="primary"
                                v-t="'button.submit'"
                                :disabled="loading || !valid"
                                :loading="loading"
                            ></v-btn>
                        </v-card-actions>
                    </v-form>
                </v-card>
            </v-flex>
        </v-layout>
    </v-container>
</template>
<script>
import loadingMixin from "@/mixins/loading"
import { mapActions } from "vuex"
export default {
    mixins: [loadingMixin],
    data() {
        return {
            rules: {
                min: (v) => (v && v.length >= 8) || this.$t("error.min", { n: 8 }),
                required: (value) => !!value || this.$t("error.required"),
            },
            showPassword: false,
            password: "",
            valid: false,
            errors: [],
        }
    },
    methods: {
        ...mapActions({ login: "user/login" }),
        async activate() {
            if (!this.$refs.form.validate()) {
                return
            }
            this.loading = true
            this.errors = []
            try {
                const {
                    data: { validateAccount },
                    errors,
                } = await this.$apollo.mutate({
                    mutation: require("@/graphql/account/validateAccount.gql"),
                    variables: {
                        token: this.$route.params.token,
                        password: this.password,
                    },
                })

                if (!validateAccount) {
                    this.errors = validateAccount.errors
                } else {
                    this.login({ token: validateAccount.jwt, locale: validateAccount.locale })

                    this.$router.push({ name: "dashboard" })
                }
            } catch (error) {
                this.errors = error.graphQLErrors.map((e) => e.message)
            }
            this.loading = false
        },
    },
}
</script>
